import { IComponentOptions } from "angular";
import { ConfigurableGridFormViewComponentController } from "./controller";

export const vsComponentName = "configurableGridFormView";

export const configurableGridFormViewComponentOptions: IComponentOptions = {
  controller: ConfigurableGridFormViewComponentController,
  controllerAs: "editController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    config: "<",
  },
};
